// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__FvNPA","disabled":"Switch_disabled__KhQJU","slider":"Switch_slider__ss3j4"};